export const symbolData = {
  0: { name: 'sym01', scalingAdjustment: 1.25 },
  1: { name: 'sym02', scalingAdjustment: 1.9 },
  2: { name: 'sym03', scalingAdjustment: 1 },
  3: { name: 'sym04', scalingAdjustment: 1.7 },
  4: { name: 'sym05', scalingAdjustment: 1.7 },
  5: { name: 'sym06', scalingAdjustment: 0.9 },
  6: { name: 'sym07', scalingAdjustment: 0.7 },
  7: { name: 'sym08', scalingAdjustment: 0.7 },
  8: { name: 'sym09', scalingAdjustment: 0.7 },
  9: { name: 'sym10', scalingAdjustment: 0.7 },
  10: { name: 'sym11', scalingAdjustment: 0.7 },
  11: { name: 'sym12', scalingAdjustment: 0.7 },
  12: { name: 'sym13', scalingAdjustment: 1 },
};